<script lang="ts">
    import { cn, type WithElementRef } from "../../../utils.js";
    import type { HTMLAttributes } from "svelte/elements";

    let {
        ref = $bindable(null),
        class: className,
        children,
        ...restProps
    }: WithElementRef<HTMLAttributes<HTMLDivElement>> & {} = $props();
</script>

<div
    bind:this={ref}
    data-slot="select-label"
    class={cn("text-muted-foreground px-2 py-1.5 text-xs", className)}
    {...restProps}
>
    {@render children?.()}
</div>
